import { LoaderService } from './../../utility/loader/loader.service';
import { ErrorMessageService } from './../../utility/error-message/error-message.service';
import { UserService } from './../../services/user.service';
import { LocalStorageService } from './../../core/localstorage.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { UserDialogboxComponent } from '../user-dialogbox/user-dialogbox.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  profileForm: FormGroup;
  userObj: any;
  roles: any;
  userRoleName: any;
  userRoleId: any;
  userId: any;
  user: any;
  countryCodeData: any = [
    { name:"+91", value:"91"},
    { name:"+1", value:"1"},
  ];
  selectedcountry: any;
  selectedFormat: any;
  private formSubmitAttempt: boolean;
  constructor(private fb: FormBuilder, private localStorage: LocalStorageService, private userService: UserService,
    private messageService: ErrorMessageService, private loader: LoaderService, private dialog: MatDialog,) {     
    this.user = this.localStorage.getFromStorage('user');
    this.userObj = this.localStorage.getFromStorage('userDetails');
    this.userId = this.localStorage.getFromStorage('userId');
    this.getroleslist();
  }

  ngOnInit() {
    this.profileForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      role: ['', [Validators.required]],
      firstName: ['', [Validators.required]],
      middleName: [],
      lastName: ['', [Validators.required]],
      // mobileNumber: ['', [Validators.required, Validators.pattern("^[0-9]{10}$")]],
      mobileNumber: ['', [Validators.required]],
      mobileCountryCode: ['',[Validators.required]],
      userId: [],
    });
    this.getUserDetail(this.userObj.email);
  }

  isFieldInvalid(field: string) {
    return (
      (this.profileForm.get(field).invalid && this.profileForm.get(field).touched) ||
      (this.profileForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  getroleslist() {
    this.userService.getroles().subscribe((data) => {
      this.roles = data;
    });
  }

  getUserDetail(userid){
    this.loader.show();
    this.userService.getUserByID(userid).subscribe(res =>{
      if(res){
        this.loader.hide();
        this.userRoleName = res.userRole;
        this.profileForm.patchValue({
          userId: res.userId,
          email: res.email,
          role: res.userRole[0].roleName,
          firstName: res.firstName,
          middleName: res.middleName,
          lastName: res.lastName,
          mobileNumber: res.mobileNumber,
          mobileCountryCode: res.mobileCountryCode
        });
        this.onChangeCode(res.mobileCountryCode);
      }
      this.loader.hide();
    });
  }

  onSubmit(){
    let obj = {
      email: this.profileForm.controls['email'].value,
      firstName: this.profileForm.controls['firstName'].value,
      lastName: this.profileForm.controls['lastName'].value,
      middleName: this.profileForm.controls['middleName'].value,
      mobileNumber: this.profileForm.controls['mobileNumber'].value,
      mobileCountryCode: this.profileForm.controls['mobileCountryCode'].value,
      userActive: true,
      userId: this.profileForm.controls['userId'].value,
      userName: this.profileForm.controls['email'].value,
    }
    this.loader.show();
    this.userService.updateuser(obj).subscribe(res => {
      if(res){
        this.loader.hide();        
        this.messageService.show('Success', 'User updated succefully', 'success');
        this.getUserDetail(this.userObj.email);
      }
    }, (error) => {
      this.messageService.show('Error', error.error.message, 'error');
      this.loader.hide();
    });
  }

  callModal(title){
    let value = { title: title, data: this.userObj };
    const dialogRef = this.dialog.open(UserDialogboxComponent, {
      data: value,
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(data => {
    });
  }

  onChangeCode(e){
    this.selectedcountry = e;
    if(e == '+1'){
      this.selectedFormat = '(000) 000-0000';
    }else if(e == '+91'){
      this.selectedFormat = '0000000000';
    }
  }

}
